import { getProfitabilityReport } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState } from 'react';
import { PROFITABILITY_SORT_OPTIONS } from '../constants/sortingOptions';

const useProfitabilityReport = () => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();

	const isLoading = hasUnfilledRequest(getProfitabilityReport);
	const [displayedRows, setDisplayedRows] = useState();

	const fetchProfitabilityData = async (dateFrom, dateTo, markets) => {
		const payload = { dateFrom, dateTo, markets };

		const response = await makeRequest(
			getProfitabilityReport.bind(null, payload),
		);

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		sortTableBy(PROFITABILITY_SORT_OPTIONS.MARKET, response.data);
	};

	const sortTableBy = (sortOption, dataToSort = displayedRows) => {
		if (sortOption === PROFITABILITY_SORT_OPTIONS.PROFITABILITY) {
			const sortedRows = dataToSort.sort(
				(a, b) => b.profitability - a.profitability,
			);

			setDisplayedRows([...sortedRows]);
		} else {
			const sortedRows = dataToSort.sort((a, b) => {
				const contractA = a.consultant?.contractType ?? '';
				const contractB = b.consultant?.contractType ?? '';
				return contractA.localeCompare(contractB);
			});
			setDisplayedRows([...sortedRows]);
		}
	};

	return {
		displayedRows,
		setDisplayedRows,
		fetchProfitabilityData,
		isLoading,
		sortTableBy,
	};
};

export default useProfitabilityReport;
